
export const sliderOptions = [{
    selector: '.slider-block__slide',
    slides: {
        perView: 1,
        spacing: 20
    },
    breakpoints: {
        '(min-width: 640px)': {
            slides: {
                perView: 2,
                spacing: 20
            }
        },
        '(min-width: 900px)': {
            slides: {
                perView: 3,
                spacing: 20
            }
        },
        '(min-width: 1200px)': {
            slides: {
                perView: 4,
                spacing: 20
            }
        }
    }
}];
